import {
  ASPECT_RATIO,
  ASPECT_RATIO_POW,
  gridPhotos
} from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 5x7, 2 - 3x5',
  imageCount: 3,
  displayGroup: 'DG_5X7_WALLET',
  calc: (height) => {
    const p1Width = (height * ASPECT_RATIO) / (2 + ASPECT_RATIO_POW);
    const p1Height = p1Width * ASPECT_RATIO;
    const p3Width = (2 * height) / (2 + ASPECT_RATIO_POW);
    const p3Height = p3Width * ASPECT_RATIO;

    return {
      gridTemplate: `
        'p1 p2' ${p1Height}px
        'p3 p3' ${p3Width}px
        / ${p1Width}px ${p1Width}px`,
      photos: [
        ...gridPhotos(1, 2, p1Width, p1Height),
        {
          gridArea: 'p3',
          width: p3Width,
          height: p3Height,
          rotation: 90
        }
      ]
    };
  }
};
